import { CountryEnum } from 'types/enums';

import { CANDADA_COPY, UK_COPY, USA_COPY } from './country';
import { LocaleData } from './localization-types';

export const localeData: LocaleData = {
  [CountryEnum.USA]: {
    dateFormat: 'MM/DD/YYYY',
    dateTimeFormat: 'MM/DD/YYYY hh:mm A',
    timeFormat: 'hh:mm A',
    currency: { currency: 'USD', locale: 'en-US' },
    copy: USA_COPY,
  },
  [CountryEnum.CANADA]: {
    dateFormat: 'MM/DD/YYYY',
    dateTimeFormat: 'MM/DD/YYYY hh:mm A',
    timeFormat: 'hh:mm A',
    currency: { currency: 'CAD', locale: 'en-CA' },
    copy: CANDADA_COPY,
  },
  [CountryEnum.UK]: {
    dateFormat: 'DD/MM/YYYY',
    dateTimeFormat: 'DD/MM/YYYY HH:mm',
    timeFormat: 'HH:mm',
    currency: { currency: 'GBP', locale: 'en-GB' },
    copy: UK_COPY,
  },
};
